// 物品等级
export default [
	// {
	//   level: 1,
	//   text: '粗糙',
	//   color: '#aaa'
	// },
	// {
	//   level: 2,
	//   text: '普通',
	//   color: '#666'
	// },
	{
		level: 1,
		text: '优秀',
		color: '#5A73DD',
    textEn: 'good'
	},
	{
		level: 2,
		text: '精良',
		color: '#C240C7',
    textEn: 'excellent'
	},
	{
		level: 3,
		text: '史诗',
		color: '#E6293F',
    textEn: 'historic'
	},
	{
		level: 4,
		text: '传说',
		color: '#E2CE27',
    textEn: 'legendary'
	}
]